import { Component, OnInit } from '@angular/core';
import { Application } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import { Search } from '../../../shared/user.model';

@Component({
  selector: 'maintenance-grid',
  templateUrl: './maintenance-grid.component.html',
  styleUrls: ['./maintenance-grid.component.css']
})
export class MaintenanceGridComponent implements OnInit {
  title="Maintainance  Office";

  itemsPerPage: number=5;
  currentPage: number=1;
  MOfficeDetailsList : any = {};
  data : any = {};  
  totalItems : number;
  s: Search;
  isSearch:boolean = false;
  Office_id : number;
  constructor(private UserService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
    this.s = new Search();
    this.isSearch = false;
   }
   ngOnInit() { 
    this.GetMOfficeDetails(this.itemsPerPage, 1)
  }

 

  //List of Case Proceedings
  GetMOfficeDetails(itemsPerPage:any,pageNo:any){
  //alert('Inside');
  this.isSearch = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.UserService.GetMOfficeDetails(itemsPerPage,pageNo);
    this.data.subscribe(
      (response: any) => {
        this.MOfficeDetailsList = response.MOfficeModel;
          this.totalItems = response.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
        console.log('office Deatils');
        console.log(this.MOfficeDetailsList);    
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401|| error.status == 500) {
          this.errorHandler.HandlerError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  delete(Office_id){
    swal({
       title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
     }).then((result) => {
        if (result.value) {
        this.data = this.UserService.DeleteMOffice(Office_id);
        this.data.subscribe(
         (response: any) => {
          this.GetMOfficeDetails(this.itemsPerPage, 1)
            //alert('Inside');;          
         },(error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401|| error.status == 500) {
            this.errorHandler.HandlerError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        }); 
    } 
    })
    }

    pageChanged(pageNumber: number) {
      if (this.isSearch)
        this.onSearch(this.s, this.itemsPerPage, pageNumber);
      else
        this.GetMOfficeDetails(this.itemsPerPage, pageNumber);
    }
  
    itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
      if (this.isSearch)
        this.onSearch(this.s, this.itemsPerPage, pageNo);
      else
        this.GetMOfficeDetails(this.itemsPerPage, pageNo);
    }


  //Search item


  onSearch(s, itemsPerPage: number, pageNo: number) {   
    this.isSearch = true;
    let searchText = this.s.SearchText;
    let searchCriteria = this.s.SearchCriteria;
    if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
      swal("Warning!", "Please enter the search criteria and search text.", "warning");
    else {
      document.getElementById('loader-spinner').style.display = "block";
      this.UserService.SearchMOffice(searchCriteria, searchText, itemsPerPage, pageNo)
        .subscribe(
          (data: any) => {
            if(data.MOfficeModel.length!=0){              
            this.MOfficeDetailsList = data.MOfficeModel;
            this.totalItems = data.TotalItemsCount;
            this.currentPage = pageNo;
            document.getElementById('loader-spinner').style.display = "none";
          }
          else
          {
          document.getElementById('loader-spinner').style.display = "none";         
          }
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401|| error.status == 500) {
              this.errorHandler.HandlerError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });
          
    }
  }



}



// WEBPACK FOOTER //
// ./src/app/masters/Maintenance-office/maintenance-grid/maintenance-grid.component.ts